import {BuilderType, PropertyTab} from 'common/widgets/cohorts-query-builder/models/enums/builder-enums';
import {LogicalOperator} from 'common/widgets/cohorts-query-builder/models/enums/expression-enums';
import {eventWasOutside} from 'common/widgets/cohorts-query-builder/util/index';
import {TrackingEvent} from 'common/widgets/cohorts-query-builder/util/tracking';

import {ClauseComponent} from './index';

const BUILDER_WIDTH = 320;
const BUILDER_RIGHT_MARGIN = 10;

export class FilterableClauseComponent extends ClauseComponent {
  get config() {
    return {
      ...super.config,
      helpers: {
        ...super.config.helpers,
        clickedInput: (ev) => ev.stopPropagation(), // don't close builder when clicking input
        getBuilderLeftOffset: () => this.state.builderScreen.leftOffset,
        getNumPropertyFilters: () => this.state.stagedCohort.getNumPropertyFilters(this.clausePosition),
        getPropertyFilterLabel: (propertyFilterIdx) => {
          return this.helpers
            .getPropertyFilterLabelParts(propertyFilterIdx)
            .map((part) => part.label)
            .join(` `);
        },
        getPropertyFilterOperator: () => {
          const logicalOperator = this.state.stagedCohort.getPropertyFilterOperator(this.clausePosition);
          return logicalOperator === LogicalOperator.And ? `all` : `any`;
        },
        getLogicalOperator: () => {
          return this.state.stagedCohort.getPropertyFilterOperator(this.clausePosition);
        },
        clickedAddFilter: () => {
          this.app.track(
            TrackingEvent.ClickAddFilter,
            this.state.stagedCohort.getTrackingDataForClause(this.clausePosition),
          );
          if (this.helpers.isBuilderOpen(BuilderType.PropertyFilter, this.clausePosition)) {
            this.app.closeBuilder(BuilderType.PropertyFilter, this.clausePosition);
          } else {
            const inputElement = this.el.querySelector(`input.cohorts-clause-builder-search-input`);
            this.app.updateStagedCohort(this.state.stagedCohort.addPropertyFilterToClause(this.clausePosition));
            const propertyTabType = this.defaultPropertyFilterTab;
            const propertyTab = propertyTabType === PropertyTab.DataGroup ? this.app.getDataGroupId() : propertyTabType;
            const builderAttrs = {
              propertyFilterIdx: this.helpers.getNumPropertyFilters(),
              propertyTab,
              propertyTabType,
              keydownProxyEl: inputElement,
            };
            this.helpers.startBuilder(BuilderType.PropertyFilter, builderAttrs);
            requestAnimationFrame(() => inputElement.focus());
          }
        },
        isBuilderOpen: (builderType, builderAttrs = {}) =>
          this.app.isBuilderOpen(builderType, this.clausePosition, builderAttrs.propertyFilterIdx),
        removePropertyFilter: (ev, propertyFilterIdx) => {
          ev.stopPropagation(); // don't want to open the builder here
          const {stagedCohort} = this.state;
          this.app.track(
            TrackingEvent.RemovePropertyFilter,
            stagedCohort.getTrackingDataForPropertyFilter(this.clausePosition, propertyFilterIdx),
          );
          this.app.closeBuilder(BuilderType.PropertyFilter, this.clausePosition, propertyFilterIdx);
          this.app.updateStagedCohort(stagedCohort.removePropertyFilter(this.clausePosition, propertyFilterIdx));
        },
        handleClickPropertyFilter: (ev, propertyFilterIdx) => {
          const isBuilderOpen = this.helpers.isBuilderOpen(BuilderType.PropertyFilter, {propertyFilterIdx});
          const selectedPropertyFilter = [...this.el.querySelectorAll(`.cohorts-clause-property-filter`)][
            propertyFilterIdx
          ];
          const clickOutsideBuilder = eventWasOutside(
            ev,
            selectedPropertyFilter.querySelector(`.cohorts-clause-builder-container`),
          );
          if (isBuilderOpen && clickOutsideBuilder) {
            ev.stopPropagation(); // don't close builder when clicking input
          } else if (clickOutsideBuilder) {
            const leftOffset = Math.round(
              Math.min(
                0,
                window.innerWidth -
                  (selectedPropertyFilter.getBoundingClientRect().left + BUILDER_WIDTH + BUILDER_RIGHT_MARGIN),
              ),
            );
            const propertyTabType = this.defaultPropertyFilterTab;
            let propertyTab;
            if (propertyTabType === PropertyTab.DataGroup) {
              propertyTab = this.state.stagedCohort.getProperty(this.clausePosition, propertyFilterIdx).dataGroupId;
            } else {
              propertyTab = propertyTabType;
            }
            this.startPropertyFilterBuilder({
              propertyFilterIdx,
              builderType: BuilderType.PropertyFilter,
              leftOffset: `${leftOffset}px`,
              extraBuilderAttrs: {propertyTab, propertyTabType},
            });
          }
        },
        togglePropertyFilterOperator: () => {
          const {stagedCohort} = this.state;
          const logicalOperator = stagedCohort.getPropertyFilterOperator(this.clausePosition);
          const newOperator = logicalOperator === LogicalOperator.And ? `any` : `all`;
          this.app.track(
            TrackingEvent.TogglePropertyFilterOperator,
            Object.assign({}, stagedCohort.getTrackingDataForClause(this.clausePosition), {operator: newOperator}),
          );
          this.app.updateStagedCohort(stagedCohort.togglePropertyFilterOperator(this.clausePosition));
        },
      },
    };
  }

  get defaultPropertyFilterTab() {
    throw new Error(`unimplemented`);
  }
}
